
import { css } from 'lit';
export default css`
.location-card-grid {
  height: 100%;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgba(232, 194, 255, var(--tw-border-opacity));
  padding: 1.5rem 1.75rem;
}

  @media (min-width: 768px) {.location-card-grid {
    padding: 2rem 1.75rem;
  }
  }

  .location-card-grid__body {
  display: flex;
}

  .location-card-grid__body {
  height: 100%;
}

  .location-card-grid__body {
  flex-direction: column;
}

  .location-card-grid__body {
  font-size: 1.125rem;
}

  .location-card-grid__content {
  margin-top: auto;
}

  .location-card-grid__title {
  margin-bottom: 1.5rem;
}

  .location-card-grid__address {
  margin-bottom: 0.5rem;
}

  .location-card-grid__address {
  display: flex;
}

  .location-card-grid__address {
  align-items: flex-start;
}

  .location-card-grid__phone {
  margin-bottom: 0.5rem;
}

  .location-card-grid__phone {
  display: flex;
}

  .location-card-grid__phone {
  align-items: flex-start;
}

  .location-card-grid__phone {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

  .location-card-grid__icon {
  margin-right: 1rem;
}

  .location-card-grid__icon {
  margin-top: 0.25rem;
}

  .location-card-grid__icon {
  height: 1rem;
}

  .location-card-grid__icon {
  width: 1rem;
}

  .location-card-grid__icon {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}
`;